<script type="text/jsx" lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_CLIPS/mixin';
import { canRemoveAddOnPlanInWinBack } from '@/views/config/shopping-cart/persist/plan-remove';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomClipsCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed:{
    isShowRemoveBtn(){
      return canRemoveAddOnPlanInWinBack(this.planType) || !this.mx_isLastBasePlan;
    }
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>)}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_new_license(plan, plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                { this.isShowRemoveBtn && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
